import { Clock3, Mail, MapPin, Phone } from "lucide-react";
import { InquiryForm } from "@/components/site/InquiryForm";
import { PageHero } from "@/components/site/PageHero";
import { SiteLayout } from "@/components/site/SiteLayout";
import { SITE_DETAILS } from "@shared/site";

const directionsUrl = "https://www.google.com/maps/dir/?api=1&destination=10400+W+103rd+St+%2322+Overland+Park+KS+66214";

export default function Contact() {
  return (
    <SiteLayout>
      <PageHero
        currentPage="Contact"
        eyebrow="Visit or contact CORE Strategies PT"
        title={<>Let’s begin with a <em>conversation.</em></>}
        description="Call the office, send a general inquiry, or find directions to the clinic at 10400 W 103rd Street in Overland Park."
        aside={
          <div className="contact-hero-card">
            <a href={SITE_DETAILS.phoneHref}><Phone size={18} /><span><small>Call the office</small>{SITE_DETAILS.phoneDisplay}</span></a>
            <a href={`mailto:${SITE_DETAILS.contactEmail}`}><Mail size={18} /><span><small>Email</small>{SITE_DETAILS.contactEmail}</span></a>
            <div><Clock3 size={18} /><span><small>Hours</small>Monday–Friday, 7 a.m.–6 p.m.</span></div>
          </div>
        }
      />

      <section className="page-section contact-section">
        <div className="container contact-grid">
          <div className="visit-panel">
            <p className="section-kicker">Visit CORE</p>
            <h2>Physical therapy in Overland Park, Kansas.</h2>
            <div className="contact-detail-list">
              <div><MapPin /><span><strong>Address</strong>{SITE_DETAILS.addressLine1}<br />{SITE_DETAILS.addressLocality}</span></div>
              <div><Phone /><span><strong>Phone</strong><a href={SITE_DETAILS.phoneHref}>{SITE_DETAILS.phoneDisplay}</a></span></div>
              <div><Clock3 /><span><strong>Office hours</strong>{SITE_DETAILS.hoursSummary}</span></div>
              <div><Mail /><span><strong>Email</strong><a href={`mailto:${SITE_DETAILS.contactEmail}`}>{SITE_DETAILS.contactEmail}</a></span></div>
            </div>
            <a className="button-secondary" href={directionsUrl} target="_blank" rel="noreferrer">Open driving directions <MapPin size={17} /></a>
            <p className="urgent-note"><strong>Need urgent medical help?</strong> Website inquiries are not monitored for emergencies. Call 911 or seek appropriate emergency care.</p>
          </div>
          <InquiryForm kind="general" heading="Send a general inquiry." />
        </div>
      </section>
    </SiteLayout>
  );
}
